import keycloakDevConfig from './keycloak.dev.config';
import MPAPIConfig from './mp-api.dev.config';

export const environment = {
  production: false,
  keycloak: keycloakDevConfig,
  mpAPI: {
    url: 'http://dso-mypurchase-dev.southeastasia.cloudapp.azure.com:8082',
    kc: 'http://dso-mypurchase-dev.southeastasia.cloudapp.azure.com:8082',
  },
  kcRealmId: '2c180cd3-6423-441d-a683-a4e4e932d35e',
  ctdUrl:"https://localhost",
  mmsURL: 'http://dso-mypurchase-dev.southeastasia.cloudapp.azure.com',
  mmscreateVendor:'https://mms-uat/vendor/create?ispermanent=false',
  mmsACL:'http://weber/qm/vm/approved%20contractor%20list%20(ACL).xlsx',
  mmsmaterialURL:'https://quartz/web/pbm/mmd/lists/mms_materialgroups/allitems.aspx',
  CreatePOPath: '/PurchaseOrder/Create/', //subjected to changes
  mmsPOPath: 'PurchaseOrder',
  sapAPIURL: '',
  sapdomain: '',
  sapUserName: '',
  sapPwd: '',
  table_fp:'',
  table_cb:'',
  airTicketMaterialGroupCode: 'M25_075',
  optForRFQReasonCode: 'P9997',
  budgetAvailabilityCheck : false,
  digitalOfficeEmailId:'digitaloffice@dsnet.dso.org.sg',
  rfsSessionExtensionWindowInMinutes: 1,
  rfsRefreshLockIntervalInMinutes: 0.75,
  rfsSessionPromptIntervalInMinutes: 29,
  mmsuserguideURL: 'http://mms-uat/',
  itemDownloadTemplateName:'ItemTemplate.xlsx',
  pmmHelpdeskEmail:'pmmhelpdesk@dso.org.sg',
  maxDocumentToVendorOverallDocumentSizeInMB: 50,
  downloadTemplateUrl:"https://singaporedso-my.sharepoint.com/:x:/r/personal/tshixuan_dso_org_sg/_layouts/15/Doc.aspx?sourcedoc=%7B7F089493-9F8E-48A2-97F6-484F9A985EDA%7D&file=Item%20Template_updated%2024Sep.xlsx&action=default&mobileredirect=true",
  isRFSChangableLessThan6K: false,
  pastPurchaseChecker: 'http://dso-mypurchase-dev.southeastasia.cloudapp.azure.com',
  faq: 'http://dso-mypurchase-dev.southeastasia.cloudapp.azure.com',
  priceAgreement: 'http://dso-mypurchase-dev.southeastasia.cloudapp.azure.com'
};
